import React from 'react';
import { AlertCircle, AlertTriangle, Check, Info, X } from 'lucide-react';

export type ToastVariant = 'success' | 'error' | 'warning' | 'info';

const variantStyle: Record<
  ToastVariant,
  { wrap: string; icon: typeof Check }
> = {
  success: { wrap: 'bg-forest-100 text-forest-700', icon: Check },
  error: { wrap: 'bg-[#F8EDEA] text-[#7A2E2E]', icon: AlertCircle },
  warning: { wrap: 'bg-[#F6EFE4] text-[#7A5A2E]', icon: AlertTriangle },
  info: { wrap: 'bg-navy-50 text-navy-600', icon: Info },
};

export const AppToast: React.FC<{
  title: string;
  message?: string;
  variant: ToastVariant;
}> = ({ title, message, variant }) => {
  const { wrap, icon: Icon } = variantStyle[variant];

  return (
    <div className="flex gap-3 pr-6">
      <span
        className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${wrap}`}
      >
        <Icon className="h-4 w-4" strokeWidth={2} />
      </span>
      <div className="min-w-0 pt-0.5">
        <p className="text-sm font-medium text-ink leading-snug">{title}</p>
        {message ? (
          <p className="mt-1 text-sm text-ink-muted leading-relaxed">{message}</p>
        ) : null}
      </div>
    </div>
  );
};

export const ToastCloseButton: React.FC<{ closeToast?: () => void }> = ({
  closeToast,
}) => (
  <button
    type="button"
    onClick={closeToast}
    aria-label="Fermer"
    className="absolute right-3 top-3 rounded-md p-0.5 text-ink-faint hover:bg-paper hover:text-ink transition-colors"
  >
    <X className="h-4 w-4" strokeWidth={1.75} />
  </button>
);
